/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Home_Newsletter_ButtonInputs */

const en_directory_home_newsletter_button = /** @type {(inputs: Directory_Home_Newsletter_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscribe`)
};

const zh_directory_home_newsletter_button = /** @type {(inputs: Directory_Home_Newsletter_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`订阅`)
};

/**
* | output |
* | --- |
* | "Subscribe" |
*
* @param {Directory_Home_Newsletter_ButtonInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_home_newsletter_button = /** @type {((inputs?: Directory_Home_Newsletter_ButtonInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Home_Newsletter_ButtonInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_home_newsletter_button(inputs)
	return zh_directory_home_newsletter_button(inputs)
});
export { directory_home_newsletter_button as "directory.home.newsletter_button" }